import React from 'react';

import { Form, FormItemProps, Input, InputNumber, InputNumberProps, InputProps } from 'antd';
import { t } from 'i18next';

type InputType =
  'name' |
  'email' |
  'phone' |
  'password' |
  'id' |
  'metainfo.description' |
  'metainfo.rating' |
  'emailProxyUrl' |
  'price' |
  'apiKey' |
  'apiUrl' |
  'address' |
  'port' |
  'login' |
  'note' |
  'customCoachPrice' |
  'customCourtPrice' |
  'priceIndividual';

interface Props {
  type: InputType;
  inputProps?: InputProps;
  formProps?: FormItemProps;
  innputNumberProps?: InputNumberProps;
}

export const InputStr = ({ type, inputProps, formProps, innputNumberProps }: Props) => {
  const renderInput = () => {
    switch (type) {
      case 'password':
        return <Input.Password {...inputProps} />;
      case 'id':
      case 'price':
      case 'port':
      case 'customCoachPrice':
      case 'customCourtPrice':
      case 'priceIndividual':
        return <InputNumber {...innputNumberProps} />;
      default:
        return <Input {...inputProps} />;
    }
  };

  return (
    <Form.Item
      label={t(`form-items.input.${type}`)}
      name={type.split('.')}
      {...formProps}
    >
      {renderInput()}
    </Form.Item>
  );
};
